import React from 'react';
import { Form, Button, Container, Spinner, Alert } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { connect } from 'react-redux';

import { showError } from '../utils/errors';
import { loginUser } from '../state/actions/auth/actions';
import { AppState } from '../store/config';
import { CenterContent } from './styles/register';
import { Link } from 'react-router-dom';

type Props = ReturnType<typeof mapStateToProps> & any;
const Login: React.FC<Props> = ({ loginUser, loading, user, error }) => {
  let history = useHistory();
  const initialValues = {
    username: '',
    email: '',
    password: '',
  };

  const { register, handleSubmit, formState, errors, reset } = useForm({
    defaultValues: { ...initialValues },
    mode: 'onChange',
  });

  const onSubmit = (data: any) => {
    loginUser(data).then((res: AxiosResponse) => {
      if (res.status === 200) {
        reset(initialValues);
        res.data.user.isSupport ? history.push('/tickets') : history.push('/');
      }
    });
  };

  return (
    <CenterContent>
      <Container>
        {error && <Alert variant="danger">{error}</Alert>}
        {user && <Alert variant="success">Successfully logged in!</Alert>}

        <h3>Login</h3>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter email"
              ref={register({
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Invalid email address format',
                },
              })}
            />
          </Form.Group>
          {showError('email', errors)}

          <Form.Group controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Password"
              ref={register({
                required: 'Password is required',
                minLength: {
                  value: 7,
                  message: 'Must be at least 7 chars long',
                },
              })}
            />
          </Form.Group>
          {showError('password', errors)}

          <Button
            block
            variant="primary"
            type="submit"
            disabled={!formState.isValid}
          >
            {loading ? (
              <Spinner animation="border" variant="light" />
            ) : (
              'Submit'
            )}
          </Button>
          <div className="account">
            Don't have an account? <Link to="/register">Register</Link>
          </div>
        </Form>
      </Container>
    </CenterContent>
  );
};

const mapStateToProps = ({ authReducer }: AppState) => ({
  loading: authReducer.loading,
  user: authReducer.user,
  error: authReducer.error,
});

export default connect(mapStateToProps, { loginUser })(Login);
